const REACT_APP_MY_ACCOUNT_DOMAIN = import.meta.env.VITE_MY_ACCOUNT_DOMAIN;

export const EXTERNAL_LINK = `${REACT_APP_MY_ACCOUNT_DOMAIN}/Account/LoginRedirect.aspx`;
export const LINK_REDIRECTION_QUERY = `?target=${REACT_APP_MY_ACCOUNT_DOMAIN}/Account/LoginRedirect.aspx?tabId=12`;
export const AMEND_DISCLAIMER =
  'it might take a couple of minutes for your appointment changes to update on our system.';
export const NOTE = 'Please note:';
